import { useState, useRef } from 'react';

export function InterestRateInput({
  label,
  onChange,
  defaultValue = null,
  maxWidth = '200px',
  setter = null,
  name = null,
  required = false,
  startValue = 200,
}) {
  const [internalValue, setInternalValue] = useState(defaultValue);
  const inputElement = useRef();

  if (setter !== null) {
    setter.current = updateValue;
  }

  function updateValue(value) {
    inputElement.current.value = (value / 100).toFixed(2).replace('.', ',');

    setInternalValue(value);

    onChange(value);
  }

  function handleChange({ target }) {
    const value = Number(
      (Number(target.value.replace(',', '.')) * 100).toFixed(0)
    ); // ikke vet jeg

    if (isNaN(value)) {
      return;
    }

    updateValue(value);
  }

  function handleMinusClick() {
    if (!internalValue) {
      return;
    }

    const value = internalValue - 1;

    updateValue(value);

    inputElement.current.focus();
  }

  function handlePlusClick() {
    const value = internalValue ? internalValue + 1 : startValue;

    updateValue(value);

    inputElement.current.focus();
  }

  return (
    <div className="root">
      <label className="label" htmlFor="interest-rate-input">
        {label}
      </label>
      <div className="inputContainer">
        <button
          type="button"
          className="inputAction inputAction--minus"
          onClick={handleMinusClick}
        >
          <span>Minus</span>
        </button>
        <input
          ref={inputElement}
          id="interest-rate-input"
          className="inputContainer__input"
          name={name}
          type="text"
          placeholder="0,00"
          inputMode="decimal"
          pattern="[0-9,]*"
          onBlur={handleChange}
          defaultValue={
            defaultValue && (defaultValue / 100).toFixed(2).replace('.', ',')
          }
          required={required}
        />
        <span className="inputContainer__percentage">%</span>
        <button
          type="button"
          className="inputAction inputAction--plus"
          onClick={handlePlusClick}
        >
          <span>Pluss</span>
        </button>
      </div>
      <style jsx>{`
        .root {
          margin-bottom: 18px;
        }

        .label {
          margin-bottom: 9px;
          display: block;
          font-weight: 600;
          color: var(--bgBlueish__text);
        }

        .inputContainer {
          position: relative;
          display: flex;
          width: 100%;
          box-sizing: border-box;
          height: 50px;
          background-color: var(--bgBlueish);
          border: 3px solid var(--bgBlueish__fadedText);
          border-radius: 4px;
        }

        .inputContainer:focus-within {
          border-color: var(--bgBlueish__tintedText);
        }

        .inputContainer__input {
          width: 50px;
          height: 100%;
          border: none;
          padding: 0;
          margin: 0 0 0 9px;
          background-color: transparent;
          font-size: 16px;
          font-weight: 500;
          font-variant-numeric: tabular-nums;
          line-height: normal;
          color: var(--bgBlueish__text);
          appearance: none;
        }

        .inputContainer__input:focus {
          outline: none;
        }

        .inputContainer__percentage {
          align-self: center;
          flex-grow: 1;
          font-weight: 500;
          color: var(--bgBlueish__text);
        }

        .inputAction {
          padding: 0 9px;
          height: 100%;
          background: none;
          border: none;
          cursor: pointer;
          touch-action: manipulation;
          color: var(--bgBlueish__text);
        }

        .inputAction:focus {
          outline: none;
        }

        .inputAction:focus span {
          box-shadow: 0 0 0 4px #a5b1fd;
        }

        .inputAction span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 22px;
          font-size: 0;
          background-color: var(--bgBlueish__fadedText);
          border-radius: 4px;
        }

        .inputAction span::before,
        .inputAction span::after {
          display: inline-block;
          border-radius: 1px;
          background-color: currentColor;
        }

        .inputAction--minus span::before {
          content: '';
          width: 12px;
          height: 4px;
        }

        .inputAction--plus span {
          position: relative;
        }

        .inputAction--plus span::before,
        .inputAction--plus span::after {
          position: absolute;
          content: '';
          width: 12px;
          height: 4px;
          top: 9px;
          left: 5px;
        }

        .inputAction--plus span::after {
          transform: rotate(90deg);
        }

        .inputContainer:focus-within .inputAction span,
        .inputAction:hover span {
          background-color: var(--bgHotBlue);
          color: var(--bgHotBlue__text);
        }
      `}</style>
      <style jsx>{`
        .inputContainer {
          max-width: ${maxWidth};
        }
      `}</style>
    </div>
  );
}
